import { useMemo } from 'react';
import {
  GridSlotsComponentsProps,
} from '@mui/x-data-grid-pro';
import { SavedFilterPreset } from 'components/common/dataGrid/filterPanelWrapper/types';
import { FilterGroupsPanel } from 'components/common/dataGrid/filterGroupsPanel';

interface UseIssueDataGridSlotPropsOptions {
  staticFilterPresets: SavedFilterPreset[];
}

export function useIssueDataGridSlotProps({
  staticFilterPresets,
}: UseIssueDataGridSlotPropsOptions): GridSlotsComponentsProps {
  return useMemo(
    () =>
      ({
      columnsManagement: {
        disableShowHideToggle: false,
        disableResetButton: true,
      },
      loadingOverlay: {
        variant: 'skeleton',
        noRowsVariant: 'skeleton',
      },
      basePopper: {
        placement: 'bottom-end',
      },
      filterPanel: {
        staticPresets: staticFilterPresets,
        // Issues only: rows in AND / OR groups (PT-7187).
        FilterForms: FilterGroupsPanel,
      },
      baseTextField: { variant: 'outlined', size: 'small' },
      baseSelect: { variant: 'outlined', size: 'small' },
      }) as GridSlotsComponentsProps,
    [staticFilterPresets]
  );
}
